theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          if (ul.nextElementSibling?.classList.contains("offcanvas__sub_menu_toggle")) return;
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.type = "button";
          if (!ul.id) ul.id = `MobileSubmenu-${Math.random().toString(36).slice(2)}`;
          const menuLabel = ul.parentNode.querySelector(":scope > a")?.textContent?.trim() || "menu";
          subMenuToggle.setAttribute("aria-label", `Open ${menuLabel} submenu`);
          subMenuToggle.setAttribute("aria-controls", ul.id);
          subMenuToggle.setAttribute("aria-expanded", "false");
          ul.parentNode.appendChild(subMenuToggle);
        });


      });
      
      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen?.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        offcanvasHeader.setAttribute("aria-hidden", "false");
        body.style.overflowY = "hidden";
        offcanvasClose?.focus();
      });
      offcanvasClose?.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        offcanvasHeader.setAttribute("aria-hidden", "true");
        body.style.overflowY = null;
        offcanvasOpen?.focus();
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              this.setAttribute("aria-expanded", "false");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                subMenu.nextElementSibling.setAttribute("aria-expanded", "false");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              this.setAttribute("aria-expanded", "true");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  subMenu.nextElementSibling.setAttribute("aria-expanded", "false");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            offcanvasHeader.setAttribute("aria-hidden", "true");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          offcanvasHeader.setAttribute("aria-hidden", "true");
          body.style.overflowY = null;
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || !offcanvasHeader.classList.contains("open")) return;
        offcanvasHeader.classList.remove("open");
        offcanvasHeader.setAttribute("aria-hidden", "true");
        body.style.overflowY = null;
        offcanvasOpen?.focus();
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
